import React from "react";
import { Printer } from "react-bootstrap-icons";
import Tooltip from "Common/Custom/Tooltip";

const PrintBtn = ({ id, apiPrintFunction, printkeysjson, title = "Receipt" }) => {

  const handlePrint = async () => {
    try {
      const res = await apiPrintFunction(id);
      if (res?.data?.success) {
        printData(res.data.data);
      }
    } catch (error) {
      console.error("Error printing:", error);
    }
  };

  const formatValue = (value, type) => {
    if (value === null || value === undefined) return "-";
    if (type === "date") return new Date(value).toLocaleDateString();
    if (type === "number") return Number(value).toFixed(2);
    return value;
  };

  const printData = (data) => {
    const rows = printkeysjson
      .map(
        (item) => `
          <tr>
            <td class="label">${item.label}</td>
            <td class="text-right">${formatValue(data[item.name], item.type)}</td>
          </tr>
        `
      )
      .join("");

    const totalRow = (data.amount != null && data.units != null)
      ? `<div class="total">Total Amount: ${(Number(data.amount) * Number(data.units)).toFixed(2)}</div>`
      : "";

    const printWindow = window.open("", "_blank");

    printWindow.document.write(`
      <html>
        <head>
          <title>${title}</title>
          <style>
            * { box-sizing: border-box; margin: 0; padding: 0; }
            body {
              font-family: Arial, sans-serif;
              padding: 30px;
              color: #333;
            }
            .invoice-box {
              max-width: 800px;
              margin: auto;
              border: 1px solid #eee;
              padding: 30px;
            }
            .header {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              margin-bottom: 24px;
            }
            .company {
              font-size: 20px;
              font-weight: bold;
            }
            .invoice-title {
              text-align: right;
            }
            .invoice-title h2 {
              font-size: 24px;
              font-weight: bold;
              margin-bottom: 4px;
            }
            .invoice-title .date {
              font-size: 14px;
              color: #555;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 8px;
            }
            table td {
              padding: 12px 10px;
              border-bottom: 1px solid #eee;
              font-size: 14px;
            }
            table tr:first-child td {
              border-top: 1px solid #eee;
            }
            .label {
              font-weight: 500;
              width: 50%;
              color: #444;
            }
            .text-right {
              text-align: right;
              color: #222;
            }
            .total {
              margin-top: 20px;
              text-align: right;
              font-size: 16px;
              font-weight: bold;
              padding-right: 10px;
            }
            .footer {
              margin-top: 30px;
              text-align: center;
              font-size: 12px;
              color: #777;
              line-height: 1.6;
            }
          </style>
        </head>
        <body>
          <div class="invoice-box">

            <div class="header">
              <div class="company">Renbow Resort</div>
              <div class="invoice-title">
                <h2>${title}</h2>
                <div class="date">Date: ${new Date().toLocaleDateString()}</div>
              </div>
            </div>

            <table>
              ${rows}
            </table>

            ${totalRow}

            <div class="footer">
              Thank you for choosing Renbow Resort.<br/>
              This is a system generated invoice.
            </div>

          </div>
        </body>
      </html>
    `);

    printWindow.document.close();
    printWindow.focus();
    printWindow.print();
    printWindow.close();
  };

  return (
    <Tooltip text="Print" position="top">
      <button
        className="btn btn-accent btn-sm border rounded-2 me-1"
        aria-label="Print"
        onClick={handlePrint}
      >
        <Printer size={18} />
      </button>
    </Tooltip>
  );
};

export default PrintBtn;
